{
  "external.scopes": "Allowed scopes",
  "external.selectAll": "Select all current scopes",
  "external.futureScopes": "New scopes will require explicit permission.",
  "external.channels": "Channels",
  "external.api": "API",
  "external.mcp": "MCP",
  "external.permission": "Permissions",
  "external.readOnly": "Read only",
  "external.readWrite": "Read and write",
  "external.advanced": "Advanced permissions",
  "external.deletePermission": "Allow deleting tasks and events through the API",
  "external.expiry": "Expiry",
  "external.noExpiry": "Leave empty for no expiry.",
  "external.save": "Save",
  "external.cancel": "Cancel",
  "external.probeFailed": "MCP check failed (HTTP {status}). Check the channel and read permissions.",
  "external.switchHelp": "Pause external access without deleting credentials. This also affects AI agents. Web and Android keep working.",
  "external.apiEnabled": "Enable external API access",
  "external.mcpEnabled": "Enable MCP access",
  "external.connect": "Connect an application",
  "external.client": "Application",
  "external.client.chatgpt": "ChatGPT",
  "external.client.claude": "Claude",
  "external.client.hermes": "Hermes",
  "external.guide.chatgpt": "In ChatGPT, enable developer mode if your account allows it. Add an MCP server under plugins/connectors, paste this URL and select OAuth. Fem-ho opens for sign-in and consent. Availability depends on your account and workspace policy.",
  "external.guide.claude": "In Claude, go to Settings → Connectors → Add custom connector. Paste this URL and connect. Authorize scopes and permissions in Fem-ho when the browser opens.",
  "external.guide.hermes": "Add this entry under mcp_servers in your Hermes configuration. Complete OAuth authorization in the browser when connecting. Then request whoami and list_tasks to verify access.",
  "external.oauthPermissions": "Each connection authorizes its own scopes and permissions. Revoke it from the credentials list. The URL must use HTTPS and be reachable by the client.",
  "external.manual": "Manual token alternative",
  "external.envHelp": "Create a token with the MCP channel and set FEMHO_MCP_TOKEN in the Hermes environment. The secret is only shown once.",
  "external.documentation": "View official documentation",
  "external.check": "Test MCP connection",
  "external.verified": "Connection verified: identity and task reading succeeded.",
  "external.closeSecret": "I have saved the token",
  "external.agentCredential": "AI agent credential",
  "external.oauthCredential": "OAuth connection",
  "external.unavailableScope": "Unavailable scope",
  "external.inheritedScopes": "Inherits the agent’s scopes",
  "external.emptyScopes": "No scopes: edit the token to grant access.",
  "external.permissionsDetail": "Detailed permissions",
  "external.lastUsed": "Last used: {date}",
  "external.expires": "Expires: {date}",
  "external.never": "No expiry",
  "external.revoked": "Revoked",
  "external.expired": "Expired",
  "external.paused": "Paused",
  "external.active": "Active",
  "external.edit": "Edit",
  "external.reconnect": "To change permissions, revoke this connection and reconnect from the application.",
  "external.authorize": "Authorize connection to Fem-ho",
  "external.consentHelp": "This application can access all tasks in the scopes you select, including Inbox. Choose only the permissions it needs.",
  "external.enableForConsent": "Enable my MCP access and authorize this connection",
  "external.allow": "Allow",
  "external.deny": "Deny",
  "settings.mail.pollInterval": "Mail check interval",
  "settings.mail.pollDefault": "Default · 5 minutes",
  "settings.mail.pollMinutes": "Every {count} min",
  "settings.mail.pollHelp": "Periodic checks, not instant delivery. Checks may take up to 30 extra seconds; failures delay retries.",
  "settings.mail.oauth.title": "Gmail and Google Workspace",
  "settings.mail.oauth.help": "Authorize access with Google and return here to confirm the address. Fem-ho will read mail without modifying messages.",
  "settings.mail.oauth.confirmEmail": "Connect the mailbox {email}?",
  "settings.mail.oauth.connected": "Connected with Google",
  "settings.mail.oauth.disconnected": "Google disconnected",
  "settings.mail.oauth.reconnect_required": "Google authorization required",
  "settings.mail.oauth.pending": "Complete authorization in your browser and return to this screen.",
  "settings.mail.oauth.confirm": "Confirm connection",
  "settings.mail.oauth.cancel": "Close or cancel",
  "settings.mail.oauth.account": "Google account",
  "settings.mail.oauth.new": "Connect a new account",
  "settings.mail.oauth.connect": "Connect with Google",
  "settings.mail.oauth.reconnect": "Reconnect Google",
  "settings.mail.oauth.disconnect": "Disconnect Google",
  "settings.mail.oauth.error.cancelled": "Authorization cancelled. The account was not changed.",
  "settings.mail.oauth.error.expired": "This attempt expired. Connect Google again.",
  "settings.mail.oauth.error.missing_scope": "Google did not grant the mail permission required for IMAP.",
  "settings.mail.oauth.error.missing_refresh_token": "Google did not grant offline access. Authorize the account again.",
  "settings.mail.oauth.error.identity_mismatch": "You selected a different Google account. Select the address of the mailbox you are reconnecting.",
  "settings.mail.oauth.error.account_exists": "This mailbox already exists. Select it in the list to reconnect it.",
  "settings.mail.oauth.error.not_configured": "The administrator must configure Google OAuth on this instance.",
  "settings.mail.oauth.error.reconnect_required": "Google access was revoked or expired. Reconnect the account.",
  "settings.mail.oauth.error.not_ready": "Authorization is not ready yet. Complete it in your browser or start again.",
  "settings.mail.oauth.error.generic": "Could not complete the Google connection. Try again.",
  "$comment": [
    "English catalogue. ca.json is the source of truth for the KEYS: this file must have",
    "exactly the same set, and i18n-parity fails if it does not.",
    "",
    "A key missing here is not a hole: t() falls back to Catalan, which is readable. A key",
    "missing everywhere shows the key itself, which is a programming error and has to be",
    "visible. The two are different failures and are kept different.",
    "",
    "Conventions, same as ca.json: sentence case throughout, CAPITALS only in the small",
    "eyebrows, the middle dot · as a separator, add buttons carry a literal +, placeholders",
    "end in a single-character …, empty states are whole sentences, and NO EMOJI.",
    "",
    "Quotation marks are the English ones (“ ”), not the guillemets used in ca and es."
  ],
  "activity.filter.ai": "AI only",
  "activity.filter.all": "Everything",
  "activity.filter.human": "People only",
  "activity.undo": "Undo",
  "activity.verb.answered": "you replied",
  "activity.verb.asked": "asked you",
  "activity.verb.cascade_complete": "was completed in cascade",
  "activity.verb.claimed": "claimed the task",
  "activity.verb.commented": "commented",
  "activity.verb.completed": "completed",
  "activity.verb.created": "created the task",
  "activity.verb.deleted": "deleted",
  "activity.verb.moved": "moved",
  "activity.verb.refreshed": "refreshed the source",
  "activity.verb.released": "released the task",
  "activity.verb.reopened": "reopened",
  "activity.verb.token_created": "created a token",
  "activity.verb.token_revoked": "revoked a token",
  "activity.verb.updated": "changed",
  "ai.attention.attachHint": "Anything you attach to the task reaches it along with the work.",
  "ai.attention.card": "Waiting on you",
  "ai.attention.pending": "{count} tasks are waiting for your reply",
  "ai.attention.waiting": "The agent needs a reply from you to carry on. It goes away when you answer.",
  "ai.coverage.disabled": "The agent “{agent}”, which handles “{scope}”, is stopped: it will pick nothing up.",
  "ai.coverage.fix": "Assign one",
  "ai.coverage.none": "No agent handles “{scope}”: whatever you leave here will not get done.",
  "ai.lock.card": "The agent is on it",
  "ai.lock.working": "The agent is working on it. It unlocks on its own at {time}.",
  "ai.mode.assisted": "Assisted",
  "ai.mode.cycle": "Change the AI mode",
  "ai.mode.delegated": "AI",
  "ai.mode.manual": "On your own",
  "ai.proof.openTask": "Open the task",
  "ai.proof.taskTitle": "Prepare Monday's meeting",
  "ai.proof.toggleLease": "Claim",
  "ai.readAt": "The agent read this {when}.",
  "ai.status.configuredButUnused": "There are model credentials, and nothing uses them yet.",
  "ai.status.credentialsWithoutProvider": "There is a key or a model configured without a provider: they will not be used.",
  "ai.takeOver.action": "I'll take it",
  "ai.takeOver.where": "Which column?",
  "ai.unseen": "There was an autonomous change you have not seen",
  "app.name": "Fem-ho",
  "board.card.advance": "Move to {column}",
  "board.column.doing": "Doing",
  "board.column.done": "Done",
  "board.column.inbox": "Inbox",
  "board.column.todo": "To do",
  "board.done.backToToday": "Back to today",
  "board.done.clear": "Clear",
  "board.done.emptyDay": "Nothing finished on {day}.",
  "board.done.showAllToday": "All of today",
  "board.done.thisWeek": "This week",
  "board.done.yesterday": "Yesterday",
  "board.drag.cancelled": "Move cancelled.",
  "board.drag.grabbed": "{title} picked up. Use the arrows to move it and space to drop it.",
  "board.drag.moved": "{title} moved to {column}.",
  "board.empty.doing": "Nothing under way right now.",
  "board.empty.done": "You have not finished anything today yet.",
  "board.empty.inbox": "Nothing in the inbox.",
  "board.empty.todo": "Nothing to do.",
  "board.fullEdit": "Full editor",
  "board.ia.badge": "AI board",
  "board.ia.empty": "The AI has nothing in this column.",
  "board.ia.newTask": "New task for the AI",
  "board.ia.toggle": "AI board",
  "board.others": "See other people's tasks",
  "board.quickAdd.failed": "Could not create it. Try again.",
  "board.quickAdd.placeholder.person": "+ Add to {column}… @Person",
  "board.quickAdd.placeholder.plain": "+ Add to {column}…",
  "board.quickAdd.placeholder.scope": "+ Add to {column}… #Scope",
  "board.quickAdd.revert": "Turn “{label}” back into text",
  "board.quickAdd.scopeRequired": "Name the scope with #{scopes}",
  "board.quickAdd.scopeRequiredPrefix": "Name the scope with #",
  "calendar.addOnDay": "Add a task on this day",
  "calendar.day": "Day",
  "calendar.empty.day": "No events or tasks on this day.",
  "calendar.empty.week": "Nothing",
  "calendar.event.fromInbox": "Remove from inbox",
  "calendar.event.inInbox": "It's in your inbox.",
  "calendar.event.notInInbox": "Not in your inbox: it stays on the calendar, but it doesn't claim your day.",
  "calendar.event.toInbox": "Add to inbox",
  "calendar.month": "Month",
  "calendar.nextMonth": "Next month",
  "calendar.noDate": "NO DATE",
  "calendar.prevMonth": "Previous month",
  "calendar.sources": "Sources",
  "calendar.sources.hide": "Hide “{name}” from the calendar",
  "calendar.sources.show": "Show “{name}” in the calendar",
  "calendar.week": "Week",
  "card.add": "Add a subtask or a list",
  "card.addPlaceholder": "New subtask… or #List item",
  "card.lists.collapsed": "▸ Lists ({count})",
  "card.lists.expanded": "▾ Lists ({count})",
  "checklist.addItem": "+ Add item…",
  "checklist.completed": "Completed",
  "checklist.completedInline": "Done items inline",
  "checklist.completedSection": "Done items in a section",
  "checklist.completedWhere": "Where done items go",
  "checklist.count": "{done}/{total}",
  "checklist.done": "List completed. Unpin it?",
  "checklist.empty": "This list has no items yet.",
  "checklist.keep": "Keep it",
  "checklist.pin": "Pin",
  "checklist.showCompleted": "Completed",
  "checklist.toggleItem": "Check or uncheck “{text}”",
  "checklist.unpin": "Unpin",
  "checklist.unpinAction": "Unpin",
  "dashboard.doing": "Doing now",
  "dashboard.empty.doing": "Nothing under way right now.",
  "dashboard.empty.overdue": "Nothing is overdue.",
  "dashboard.empty.today": "Nothing for today.",
  "dashboard.overdue": "Overdue",
  "dashboard.overdueCount": "{count} overdue",
  "dashboard.pending": "{count} pending",
  "dashboard.quickAdd": "+ Add… #Scope @Person",
  "dashboard.title": "Overview",
  "dashboard.today": "Today",
  "error.body-required": "An empty comment says nothing: write the reason in it.",
  "error.calendar-not-empty": "“{name}” still has {count} events. Move or delete them first.",
  "error.calendar-read-only": "“{name}” is a read-only source and cannot be written to.",
  "error.cannot-delete-self": "You cannot delete your own account from Admin. Ask another administrator.",
  "error.capabilities-exceeded": "None of the requested capabilities are yours: a token cannot do more than whoever creates it.",
  "error.capabilities-required": "A token with no capabilities cannot do anything: pick at least one.",
  "error.claimed-by-other": "Another agent has it claimed for {minutes} more min.",
  "error.confirmation-mismatch": "To wipe the instance, type its exact name: “{name}”.",
  "error.email-taken": "There is already an account with {email}.",
  "error.endpoint-required": "The endpoint being unsubscribed has to be given.",
  "error.event-incomplete": "An event needs a calendar, a title and a start instant.",
  "error.generic": "Something went wrong.",
  "error.human-took-over": "A person has taken this task over: it is no longer the AI's.",
  "error.invalid-ai-mode": "The mode has to be manual, assisted or delegated.",
  "error.invalid-credentials": "Wrong email or password.",
  "error.invalid-email": "That does not look like an email address.",
  "error.invalid-permission": "The permission has to be view, check or comment. There is no edit one.",
  "error.invalid-subscription": "This subscription is missing data.",
  "error.invalid-timezone": "“{value}” is not a time zone. Use a name like Europe/Madrid.",
  "error.invalid-value": "“{value}” is not a {field} value. The valid ones are: {allowed}.",
  "error.invite-invalid": "This invitation is not valid, has already been used, or has expired.",
  "error.label-other-scope": "The {name} label belongs to another scope. Create it in this one too.",
  "error.last-admin": "That is the last administrator. The instance would be left with nobody able to administer it.",
  "error.last-owner": "{name} would be left with no owner. Make someone else an owner first.",
  "error.member-shape": "A member is a person or a calendar subscription, never both and never neither.",
  "error.missing-capability": "This token does not have the “{capability}” capability.",
  "error.name-required": "A token with no name cannot be told apart from the others, and then none can be revoked with confidence.",
  "error.no-lease": "This task is not claimed.",
  "error.not-a-member": "{person} is not a member of {scope}: they could not open the task.",
  "error.not-claimed": "You have not claimed this task.",
  "error.not-creatable": "This cannot be created from a batch.",
  "error.not-found": "This is no longer here.",
  "error.not-owner": "The {name} scope can only be deleted by whoever created it.",
  "error.not-undoable": "This is not an autonomous AI change with previous values: there is nothing to restore.",
  "error.occurrence-required": "Which occurrence is being touched has to be known.",
  "error.parent-required": "Where it goes has to be given.",
  "error.password-too-short": "The password has to be at least 10 characters.",
  "error.project-other-scope": "The {name} project belongs to another scope. A task does not change scope by editing it.",
  "error.reason-required": "Releasing a task needs a reason: the next agent has to be able to read it.",
  "error.retry": "Try again",
  "error.scope-forbidden": "This token does not reach this scope. It sees: {visible}.",
  "error.scope-not-collective": "The {name} scope is individual: it has no members. Collective ones do.",
  "error.scope-not-empty": "The {name} scope still has {contents}. Move it or delete it first.",
  "error.scope-required": "This always belongs to a scope.",
  "error.setup-closed": "This instance already has an administrator.",
  "error.share-revoked": "This link is revoked: it cannot be reopened. Create a new one.",
  "error.source-url-required": "The source needs an address.",
  "error.target-required": "A link is for a task or for a checklist, not for both and not for neither.",
  "error.task-locked": "The agent “{agent}” is working on it right now. It unlocks on its own in {minutes} min.",
  "error.text-required": "This cannot be left empty.",
  "error.title-required": "The title cannot be left empty.",
  "error.too-many-attempts": "Too many attempts. Try again in {seconds} seconds.",
  "error.unauthenticated": "You have to sign in again.",
  "error.unknown-entity": "This is not something that syncs.",
  "error.unreachable": "The server is not answering. It is not what you typed: check whether the instance is running.",
  "error.version-conflict": "Someone else changed this in the meantime.",
  "error.weak-share-password": "The link password needs at least {min} characters.",
  "error.window-invalid": "The dates of the window are not valid.",
  "error.window-required": "A window is needed: without one, recurrences cannot be expanded.",
  "error.wrong-component": "“{name}” is for tasks and does not accept events.",
  "error.wrong-password": "The current password is not correct.",
  "inbox.day.next": "Next day",
  "inbox.day.pick": "Pick a day",
  "inbox.day.prev": "Previous day",
  "inbox.day.today": "Today",
  "inbox.event.allDay": "All day",
  "inbox.event.toTask": "Make it a task",
  "inbox.eye.hide": "Remove from the Tasks inbox",
  "inbox.eye.show": "Move to the Tasks inbox",
  "inbox.mail.noSubject": "(no subject)",
  "inbox.mail.unknownSender": "No sender",
  "inbox.mailbox": "What the inbox shows",
  "inbox.mailbox.all": "All",
  "inbox.mailbox.allHint": "The whole inbox: both individual and shared scopes",
  "inbox.mailbox.own": "Individual",
  "inbox.mailbox.ownHint": "Only what is in your individual scopes",
  "inbox.mailbox.shared": "Shared",
  "inbox.mailbox.sharedHint": "Only what is in the scopes you share with someone",
  "inbox.section.events": "From the calendar",
  "inbox.section.mail": "From mail",
  "invite.done": "You can now sign in with your email and this password.",
  "invite.mismatch": "The two passwords do not match.",
  "invite.password": "Password",
  "invite.repeat": "Repeat it",
  "invite.subtitle": "This link works once.",
  "invite.title": "Choose your password",
  "invite.tooShort": "It has to be at least 10 characters.",
  "join.accept": "Join",
  "join.done": "You are in",
  "join.invalid": "This invitation is not valid: it may have been used, or expired.",
  "join.subtitle": "{who} invites you to “{scope}”",
  "join.title": "An invitation",
  "login.checkServer": "Check",
  "login.email": "Email",
  "login.error": "Wrong email or password.",
  "login.forgot": "Forgotten your password?",
  "login.insecure": "This address is not encrypted. Anyone on the network can read what goes through it.",
  "login.password": "Password",
  "login.register": "Create an account",
  "login.server": "Server",
  "login.serverHint": "The address of your Fem-ho server",
  "login.serverNewer": "The server is newer than this app. Update it.",
  "login.serverUnreachable": "There is no Fem-ho at this address.",
  "login.submit": "Sign in",
  "login.subtitle": "The task manager for you and the family",
  "nav.add": "Add",
  "nav.allProjects": "All projects",
  "nav.back": "‹ Back",
  "nav.backToBoard": "‹ Back to the board",
  "nav.calendar": "Calendar",
  "nav.cancel": "Cancel",
  "nav.close": "Close",
  "nav.create": "Create",
  "nav.dashboard": "Overview",
  "nav.delete": "Delete",
  "nav.estadistiques": "Stats",
  "nav.lastScope": "At least one scope has to stay on.",
  "nav.logout": "Sign out",
  "nav.newChecklist": "+ New list",
  "nav.newChecklistFull": "New simple task list",
  "nav.newProject": "+ New project",
  "nav.newProject.client": "New client",
  "nav.noPinned": "No pinned lists. Pin a simple list from a task.",
  "nav.openDashboard": "Open the overview",
  "nav.pinned": "Pinned lists",
  "nav.pinnedProgress": "{done} of {total} done",
  "nav.profile": "Your account",
  "nav.projectToggle": "Show or hide the project {name}",
  "nav.registre": "Log",
  "nav.rename": "Rename",
  "nav.retry": "Try again",
  "nav.save": "Save",
  "nav.scopePicker": "Which scope you are in",
  "nav.scopeProjects": "Projects in the {name} scope",
  "nav.scopeToggle": "Show or hide the {name} scope",
  "nav.search": "Search",
  "nav.settings": "Settings",
  "nav.tasks": "Tasks",
  "nav.view": "View",
  "notify.reminder": "Reminder",
  "palette.empty": "Nothing matches.",
  "palette.go": "Go to",
  "palette.placeholder": "Type to go somewhere or find a task…",
  "palette.tasks": "Tasks",
  "quickadd.groupOwn": "Mine",
  "quickadd.groupShared": "Shared",
  "register.error": "The account could not be created.",
  "register.haveAccount": "I already have an account",
  "register.name": "Username",
  "register.submit": "Create the account",
  "register.subtitle": "Pick a name and a password. You can change them later in Settings.",
  "register.title": "Create an account",
  "registre.allProjects": "All projects",
  "registre.allProjects.client": "All clients",
  "registre.chrono.addLane": "+ Add a project…",
  "registre.chrono.fit": "Fit",
  "registre.chrono.hint": "Drag a block to move it, its edges to stretch it. Snaps to 5 min.",
  "registre.chrono.zoom": "Zoom",
  "registre.col.person": "Person",
  "registre.col.project": "Project",
  "registre.col.project.client": "Client",
  "registre.col.task": "Task",
  "registre.col.time": "Time",
  "registre.col.type": "Type",
  "registre.col.when": "Date and time",
  "registre.day": "Day",
  "registre.empty": "Nothing logged in this period yet.",
  "registre.everyone": "Everyone",
  "registre.export": "Export CSV",
  "registre.noProject": "Internal",
  "registre.noScopes": "No active scope logs time. Turn it on in Settings ▸ Scopes.",
  "registre.open": "Being worked on right now.",
  "registre.overtimeCell": "{time} outside hours",
  "registre.overtimeTotal": "{time} outside hours",
  "registre.period.all": "Everything",
  "registre.period.days30": "Last 30 days",
  "registre.period.days90": "Last 90 days",
  "registre.period.month": "This month",
  "registre.period.today": "Today",
  "registre.period.week": "This week",
  "registre.review": "A long stretch in one go: worth a look.",
  "registre.search": "Search…",
  "registre.subtitle": "Everything done: when, for which project, who and how long.",
  "registre.summary": "{tasks} tasks · {time} logged",
  "registre.timezone": "Times are shown in {zone}.",
  "registre.title": "Log",
  "registre.view.chrono": "Timeline",
  "registre.view.table": "Table",
  "settings.about": "About",
  "settings.accent": "Accent",
  "settings.accent.default": "Default",
  "settings.accent.mono-cool": "Cool",
  "settings.accent.mono-warm": "Warm",
  "settings.accent.soft": "Soft",
  "settings.addMember": "+ Add member",
  "settings.agentAllScopes": "All scopes",
  "settings.agentCanCreate": "Can create tasks",
  "settings.agentConnect": "How to connect it",
  "settings.agentCredentials": "Credentials",
  "settings.agentDownloadMcp": "Download the .mcp.json",
  "settings.agentDownloadSkill": "Download the instruction sheet",
  "settings.agentEnabled": "Active",
  "settings.agentMcpHasToken": "It carries the credential: anyone with this file can read and write your tasks.",
  "settings.agentMcpNoToken": "The credential is missing: create one and copy this then, which is when it is shown.",
  "settings.agentNewCredential": "+ New credential",
  "settings.agentScopeTaken": "“{name}” handles this scope: a scope can only have one agent.",
  "settings.agentScopes": "Scopes it handles",
  "settings.agentSkillNoToken": "It carries no credential: it is only how it should behave.",
  "settings.agents": "Agents",
  "settings.branding": "Instance logo",
  "settings.branding.fixed": "The logo comes from the server configuration (FEMHO_LOGO_URL) and cannot be changed here.",
  "settings.branding.help": "SVG, PNG or WebP, 512 KB at most. It appears in the bar, on the login page and on a shared link.",
  "settings.branding.none": "This instance has no logo yet: its name is shown.",
  "settings.branding.remove": "Remove the logo",
  "settings.caldavEvents": "Events",
  "settings.caldavTodos": "Tasks",
  "settings.caldavUrls": "Your Fem-ho CalDAV addresses",
  "settings.calendarCredWarning": "This calendar has stored credentials. Members will see its events, but the credentials never leave. If it is also two-way, what they edit will be written to a third-party service using yours.",
  "settings.calendarPrivate": "Only you",
  "settings.calendarShared": "Shared",
  "settings.calendarSource": "CalDAV source",
  "settings.changePassword": "Change the password",
  "settings.credits": "Fem-ho © 2026 Borja Balsera · The design system is Plou, from a separate product and under its own terms · Roboto typeface (SIL Open Font License) · See the NOTICE file in the repository",
  "settings.currentPassword": "Current password",
  "settings.dashboardItems": "What shows in the overview",
  "settings.day.fri": "Fr",
  "settings.day.mon": "Mo",
  "settings.day.sat": "Sa",
  "settings.day.sun": "Su",
  "settings.day.thu": "Th",
  "settings.day.tue": "Tu",
  "settings.day.wed": "We",
  "settings.empty.agents": "You have not created any agent yet.",
  "settings.empty.calendars": "No content for Calendars yet.",
  "settings.empty.shares": "No content for Shared yet.",
  "settings.enableAi": "Turn on the AI user",
  "settings.events.onDelete": "When you delete a task made from an event",
  "settings.events.onDelete.hide": "The event stays out",
  "settings.events.onDelete.hideHint": "It remains on the calendar, but stops claiming your day.",
  "settings.events.onDelete.return": "The event returns to the inbox",
  "settings.events.onDelete.returnHint": "Deleting the task undoes the conversion.",
  "settings.gravatar": "Use Gravatar for my picture",
  "settings.gravatarFill": "Fill in from Gravatar",
  "settings.gravatarHelp": "The server asks gravatar.com for your picture using a hash of your email. The hash is not anonymous: anyone who already suspects your address can check it. Turn this off and your initials are shown instead.",
  "settings.gravatarNothing": "Gravatar has nothing for this address.",
  "settings.inbox.below": "Below",
  "settings.inbox.left": "Left",
  "settings.inbox.right": "Right",
  "settings.inboxPosition": "Position of the inbox rail",
  "settings.inboxShowOverdue": "The inbox shows overdue tasks",
  "settings.invite": "Invite someone",
  "settings.inviteCreate": "Create invitation",
  "settings.inviteEmail": "Email",
  "settings.inviteLink": "Invitation link",
  "settings.inviteName": "Name",
  "settings.inviteNone": "No open invitations.",
  "settings.inviteOnce": "Copy it now: it cannot be shown again.",
  "settings.inviteOpen": "Open invitations",
  "settings.invitePending": "Invited, has not signed in yet",
  "settings.inviteRevoke": "Revoke",
  "settings.inviteRole": "What they can do",
  "settings.language": "Language",
  "settings.longSession": "Flag for review from (hours)",
  "settings.mail.accounts": "Accounts",
  "settings.mail.add": "Add the account",
  "settings.mail.addRule": "Map the folder",
  "settings.mail.appPassword": "Fastmail and iCloud require an app password. For personal Gmail, enable 2-Step Verification and use the 16-character app password; you may paste it with spaces. If the Google Workspace admin requires OAuth, Fem-ho cannot connect the account yet.",
  "settings.mail.attachmentsToTask": "The mail attachments, onto the task",
  "settings.mail.bodyToDescription": "The mail body, into the description",
  "settings.mail.empty": "No mail account yet.",
  "settings.mail.firstRun": "The first read of a folder ingests nothing: it starts from now.",
  "settings.mail.folder": "Folder",
  "settings.mail.folderPlaceholder": "Folder name",
  "settings.mail.foldersFailed": "Could not read them. Type it.",
  "settings.mail.host": "IMAP server",
  "settings.mail.inboxVisible": "Shows in the Tasks inbox",
  "settings.mail.intro": "Mail accounts are yours, not the household's: nobody else sees them, not even the admin.",
  "settings.mail.lastPolled": "Last read: {when}",
  "settings.mail.loadingFolders": "Reading the folders…",
  "settings.mail.name": "Name",
  "settings.mail.neverPolled": "Not read yet.",
  "settings.mail.notTouched": "Nothing marks your mail as read.",
  "settings.mail.password": "Password",
  "settings.mail.passwordKept": "Saved. Leave it blank.",
  "settings.mail.passwordKept.long": "Already saved. Leave the field blank to keep it.",
  "settings.mail.pickFolder": "Pick a folder…",
  "settings.mail.port": "Port",
  "settings.mail.project": "Project",
  "settings.mail.projectNone": "The general space",
  "settings.mail.remove": "Remove",
  "settings.mail.rules": "Folders",
  "settings.mail.rules.empty": "No folder mapped. A folder without a rule is never read.",
  "settings.mail.save": "Save",
  "settings.mail.scope": "Scope",
  "settings.mail.security": "Security",
  "settings.mail.security.starttls": "STARTTLS · port 143",
  "settings.mail.security.tls": "TLS · port 993",
  "settings.mail.template": "Task title",
  "settings.mail.templatePreset": "Sender - Subject",
  "settings.mail.templatePreview": "It will read: {preview}",
  "settings.mail.templateUnknown": "Variables that don't exist: {vars}",
  "settings.mail.test": "Test the connection",
  "settings.mail.testFail": "It didn't work: {error}",
  "settings.mail.testOk": "Connected. {count} folders.",
  "settings.mail.testing": "Testing…",
  "settings.mail.username": "User",
  "settings.mcpEnable": "Turn on MCP",
  "settings.mcpInstructions": "To connect a client, use this address and a token with the capabilities you want to give it.",
  "settings.mcpUrl": "MCP URL",
  "settings.memberRemove": "Remove",
  "settings.members": "Members",
  "settings.newAgent": "+ New agent",
  "settings.newCalendar": "+ New calendar",
  "settings.newPassword": "New password",
  "settings.newProject": "New project",
  "settings.newScope": "+ New scope",
  "settings.noProjects": "No projects in this scope.",
  "settings.noun.client": "Clients",
  "settings.noun.project": "Projects",
  "settings.overtimeVisible": "Show time outside hours as overtime",
  "settings.passwordChanged": "Password changed. The other sessions were closed.",
  "settings.profileEmail": "Email",
  "settings.profileName": "Name",
  "settings.projectDelete": "Delete the project",
  "settings.projectName": "Project name",
  "settings.projects": "Projects",
  "settings.projectsHelp": "A project lives inside a scope. Quick add reaches it with #Scope/Project.",
  "settings.role.admin": "Administrator",
  "settings.role.collaborator": "Collaborator",
  "settings.role.member": "Member",
  "settings.role.owner": "Owner",
  "settings.role.viewer": "Read only",
  "settings.scopeCancel": "Cancel",
  "settings.scopeColor": "Colour",
  "settings.scopeDelete": "Delete scope",
  "settings.scopeDeleteConfirm": "“{name}” will be deleted. Only possible if it is empty.",
  "settings.scopeEdit": "Edit",
  "settings.scopeJoin": "Sync",
  "settings.scopeKind": "Kind",
  "settings.scopeKind.collective": "Collective",
  "settings.scopeKind.individual": "Individual",
  "settings.scopeLeave": "Leave scope",
  "settings.scopeLeaveConfirm": "You will stop seeing “{name}” and everything in it.",
  "settings.scopeMode": "How you split your work",
  "settings.scopeMode.both": "each person chooses",
  "settings.scopeMode.fixed": "This instance is set to “{mode}” and this cannot be changed here.",
  "settings.scopeMode.help": "You can change this whenever you like: nothing moves and nothing is deleted, only what the top bar shows.",
  "settings.scopeMode.multi": "By scope",
  "settings.scopeMode.multi.hint": "Scopes in the bar: Personal, Work, Family… with projects inside each one.",
  "settings.scopeMode.single": "By project",
  "settings.scopeMode.single.hint": "Projects in the bar. Scopes still exist and are picked on the left.",
  "settings.scopeName": "Name",
  "settings.scopeOwner": "Owner",
  "settings.scopeSave": "Save",
  "settings.scopeServerUrl": "Server address (https://…)",
  "settings.scopeSource.here": "From this server",
  "settings.scopeSource.new": "New",
  "settings.scopeSource.remote": "From another server",
  "settings.scopeSourceHelp": "Whoever shares the scope gives you a token. From this same server the token is enough; from another one, the address too.",
  "settings.scopeToken": "Paste the invitation token",
  "settings.sharedCalendars": "Shared calendars",
  "settings.showCalendarWidget": "Small calendar",
  "settings.showOverdueSection": "Overdue section",
  "settings.source": "This instance runs Fem-ho {version}, licensed under {license}.",
  "settings.sourceLink": "The source",
  "settings.sources": "Data sources",
  "settings.sources.add": "+ Add source",
  "settings.sources.empty": "This scope has no external sources. The ones you add will show up in the calendar.",
  "settings.sources.failed": "The last refresh failed: {reason}",
  "settings.sources.inbox": "In the inbox",
  "settings.sources.kind.caldav": "CalDAV",
  "settings.sources.kind.ical": "iCal",
  "settings.sources.kind.rss": "RSS",
  "settings.sources.name": "Name",
  "settings.sources.never": "Not refreshed yet.",
  "settings.sources.password": "Password",
  "settings.sources.readOnly": "Read only.",
  "settings.sources.refreshed": "Refreshed {when}.",
  "settings.sources.remove": "Remove",
  "settings.sources.url": "Address",
  "settings.sources.urlRequired": "The source needs an address.",
  "settings.sources.username": "User",
  "settings.empty.admin": "No content for Admin yet.",
  "settings.empty.ai": "No content for AI user yet.",
  "settings.empty.mail": "No content for Mail yet.",
  "settings.empty.mcp": "No content for MCP and API yet.",
  "settings.empty.profile": "No content for Profile yet.",
  "settings.empty.scopes": "No content for Scopes yet.",
  "settings.tab.admin": "Admin",
  "settings.tab.ai": "AI user",
  "settings.tab.calendars": "Calendars",
  "settings.tab.general": "General",
  "settings.tab.mail": "Mail",
  "settings.tab.mcp": "MCP and API",
  "settings.tab.profile": "Profile",
  "settings.tab.scopes": "Scopes",
  "settings.tab.shares": "Shared",
  "settings.theme": "Theme",
  "settings.theme.dark": "Dark",
  "settings.theme.light": "Light",
  "settings.theme.system": "System",
  "settings.timezone": "Time zone",
  "settings.title": "Settings",
  "settings.tracking": "Time log",
  "settings.trackingBackfilled": "{count} time blocks recovered from the history.",
  "settings.trackingHelp": "When a task goes through “Doing”, the time it spends there is logged. Turning this on recovers what is already in the history.",
  "settings.trackingOn": "Log time in this scope",
  "settings.typeNew": "New type",
  "settings.typesOn": "Use task types",
  "settings.typesRequired": "Required to create a task",
  "settings.update.available": "Version {version} is out.",
  "settings.update.see": "See what changed",
  "settings.update.unreachable": "Could not check whether there is a newer version.",
  "settings.users": "Household members",
  "settings.weekStart": "First day of the week",
  "settings.weekStart.auto": "Follow the language ({day})",
  "settings.wipe": "Wipe the instance",
  "settings.wipeConfirm": "Type “{name}” to confirm",
  "settings.wipeWarning": "This deletes every task, event, list and the history. The accounts stay.",
  "settings.workHours": "Working hours",
  "setup.name": "Your name",
  "setup.scope.family": "Family",
  "setup.scope.personal": "Personal",
  "setup.scope.work": "Work",
  "setup.submit": "Create the account",
  "setup.subtitle": "Create the first administrator account of this instance.",
  "setup.title": "Let's begin",
  "share.accesses": "Visits",
  "share.enter": "Enter",
  "share.enterName": "What is your name?",
  "share.enterPassword": "This link asks for a password",
  "share.expired": "This link is no longer valid.",
  "share.expiresAt": "Expires on",
  "share.lastAccess": "Last visit",
  "share.maxViews": "Maximum visits",
  "share.password": "Password",
  "share.passwordPlaceholder": "No password",
  "share.permission": "What the person opening the link can do",
  "share.permission.check": "Check items",
  "share.permission.comment": "Check and comment",
  "share.permission.view": "Look only",
  "share.pointsTo": "Points to",
  "share.requireName": "Ask for the name of whoever comes in",
  "share.revoke": "Revoke",
  "share.revoked": "Revoked",
  "share.title": "Share",
  "share.wrong": "There is no way in with that.",
  "shortcuts.calendar": "Calendar",
  "shortcuts.close": "Close",
  "shortcuts.dashboard": "Overview",
  "shortcuts.help": "This help",
  "shortcuts.quickAdd": "Go to the quick add",
  "shortcuts.scopeN": "Toggle scope N",
  "shortcuts.search": "Search",
  "shortcuts.settings": "Settings",
  "shortcuts.tasks": "Tasks",
  "shortcuts.title": "Keyboard shortcuts",
  "source.caldav": "From a CalDAV calendar",
  "source.ical": "From a subscribed calendar",
  "source.mail": "From an email",
  "source.rss": "From an RSS feed",
  "state.empty.pinned": "You have no pinned lists.",
  "state.empty.projects": "This scope has no projects yet.",
  "state.empty.scopes": "You have no scopes yet. Create one in Settings.",
  "state.empty.search": "Nothing found.",
  "state.loading": "Loading…",
  "stats.average": "Average per task",
  "stats.byPerson": "Time by person",
  "stats.byProject": "Time by project",
  "stats.byProject.client": "Time by client",
  "stats.byType": "Time by type",
  "stats.evolution": "Time over the period",
  "stats.evolutionWeekly": "Time over the period, by week",
  "stats.noType": "No type",
  "stats.overtime": "Overtime by project",
  "stats.overtime.client": "Overtime by client",
  "stats.period.all": "Everything",
  "stats.period.days30": "Last 30 days",
  "stats.period.days365": "Last year",
  "stats.period.days7": "Last 7 days",
  "stats.period.days90": "Last 90 days",
  "stats.projects": "Active projects",
  "stats.projects.client": "Active clients",
  "stats.subtitle": "Where the time goes: by type, by project, by person, and how it changes over time.",
  "stats.tasks": "Tasks done",
  "stats.title": "Stats",
  "stats.total": "Total time",
  "sync.appliedByServer": "Applied by the server",
  "sync.complete": "Mark as done",
  "sync.conflict": "This task changed on both sides. Which version do you want?",
  "sync.goOffline": "Disconnect",
  "sync.goOnline": "Reconnect",
  "sync.keepMine": "Mine",
  "sync.keepTheirs": "The other device's",
  "sync.now": "Sync now",
  "sync.offline": "Offline",
  "sync.online": "Online",
  "sync.pending": "Waiting to upload",
  "sync.remoteEdit": "Change from another device",
  "sync.rename": "Rename",
  "sync.renameSuffix": "·",
  "sync.synced": "Synced",
  "sync.title": "Sync",
  "task.activity": "History",
  "task.addAttachment": "Attach a file",
  "task.aiConversation": "Conversation with the AI",
  "task.aiInstructions": "Instructions for the AI",
  "task.aiMode": "AI mode",
  "task.aiReply": "Reply to the agent…",
  "task.assignees": "Assigned to",
  "task.attachmentLink": "External link",
  "task.attachmentTooBig": "The file is over the {limit_mb} MB limit.",
  "task.attachments": "Attachments",
  "task.checklists": "Simple lists",
  "task.comments": "Comments",
  "task.deadline": "Deadline",
  "task.deleteConfirm": "Permanently delete “{title}”? Its subtasks and lists will also be deleted. If it came from a calendar event, the event will be kept.",
  "task.description": "Description",
  "task.dueDate": "Date",
  "task.dueTime": "Time",
  "task.edit": "Edit task",
  "task.empty.activity": "Nothing has happened in this task yet.",
  "task.empty.aiConversation": "Nothing said yet.",
  "task.empty.attachments": "No files attached.",
  "task.empty.comments": "No comments yet.",
  "task.empty.labels": "This scope has no labels yet.",
  "task.empty.subtasks": "This task has no subtasks.",
  "task.label.add": "Add this label",
  "task.label.remove": "Remove this label",
  "task.labels": "Labels",
  "task.new": "New task",
  "task.newChecklist": "+ New list",
  "task.newComment": "Write a comment…",
  "task.newLabel": "+ New label",
  "task.newLabel.placeholder": "Label name",
  "task.newSubtask": "+ Add subtask…",
  "task.noProject": "General space",
  "task.project": "Project",
  "task.project.client": "Client",
  "task.recurrence": "Repeat",
  "task.recurrence.daily": "Every day",
  "task.recurrence.explain": "With this, the next one counts from the day you do it, not from the due date.",
  "task.recurrence.fromCompletion": "Count from when it is done",
  "task.recurrence.monthly": "Every month",
  "task.recurrence.none": "Does not repeat",
  "task.recurrence.weekly": "Every week",
  "task.recurrence.yearly": "Every year",
  "task.removeAttachment": "Remove",
  "task.scope": "Scope",
  "task.send": "Send",
  "task.share": "Share",
  "task.status": "Status",
  "task.subtasks": "Subtasks",
  "task.taskType": "Type",
  "task.title": "Title",
  "task.titleEditHint": "Hold the title and release to edit · F2 with the keyboard",
  "task.titleEditKeys": "Enter to save · Escape to cancel",
  "task.titleRequired": "The title cannot be empty.",
  "tokens.aiOwned": "AI credential for “{name}”",
  "tokens.aiOwnedGo": "Go to the agent",
  "tokens.aiOwnedHelp": "AI credentials are created and revoked in AI user, which also says which scopes each agent handles.",
  "tokens.capabilities": "Capabilities",
  "tokens.copied": "Copied",
  "tokens.copy": "Copy",
  "tokens.create": "Create a token",
  "tokens.lastUsed": "Last used",
  "tokens.name": "Name",
  "tokens.never": "Never",
  "tokens.onceWarning": "Write it down now: it will never be shown again.",
  "tokens.prefix": "Prefix",
  "tokens.revoke": "Revoke",
  "tokens.scopes": "Scopes",
  "tokens.title": "API tokens",
  "welcome.changeable": "You can change this any time in Settings. Nothing moves and nothing is deleted.",
  "welcome.lead": "Pick how you want to see Fem-ho. There is no wrong answer and you can change it later.",
  "welcome.multi": "By areas of life",
  "welcome.multi.body": "The bar shows Personal, Work, Family… and you can look at one or several at once. Each scope can hold projects.",
  "welcome.preview.family": "Family",
  "welcome.preview.personal": "Personal",
  "welcome.preview.projectA": "Building",
  "welcome.preview.projectB": "Clients",
  "welcome.preview.scope": "Work",
  "welcome.preview.work": "Work",
  "welcome.single": "By projects of a single thing",
  "welcome.single.body": "The bar shows your projects. Good if you use Fem-ho for one thing: your job, your company, a project.",
  "welcome.title": "How do you split your work?",
  "widget.board.description": "Choose Inbox, To do or Doing and tap a task to advance it.",
  "widget.board.name": "Fem-ho · Tasks",
  "widget.more": "+{count} more",
  "widget.pending": "pending",
  "widget.pinned.choose": "Choose which list to show",
  "widget.pinned.description": "A pinned list, to tick off from the home screen.",
  "widget.pinned.name": "Fem-ho · List",
  "widget.quickAdd.description": "Jot down a task without opening the app.",
  "widget.quickAdd.name": "Fem-ho · Add",
  "widget.signedOut": "Sign in to see your tasks.",
  "widget.today.description": "What is due today, with quick add.",
  "widget.today.name": "Fem-ho · Today",
  "settings.noMembers": "No members.",
  "settings.scopeType": "Type",
  "settings.scopeType.individual": "Individual",
  "settings.scopeType.collective": "Collective",
  "settings.inviteUrl": "Invitation link",
  "settings.invites": "Invitations",
  "settings.noInvites": "No open invitations.",
  "settings.workStart": "Start time",
  "settings.workEnd": "End time",
  "settings.workDays": "Work days",
  "settings.longSessionHours": "Long session hours",
  "settings.labelNew": "+ New label",
  "settings.labelDelete": "Delete label",
  "settings.typeDelete": "Delete task type",
  "settings.entityLabels": "Labels",
  "settings.entityTypes": "Task types",
  "settings.entityDedication": "Time tracking",
  "settings.entityProjects": "Projects",
  "settings.scopeSection": "Scope management",
  "notification.snooze": "Snooze",
  "login.certTitle": "Unrecognized certificate",
  "login.certBody": "The server presents a self-signed certificate or one from its own CA. Compare the fingerprint with the one you expect and, if it matches, confirm it to connect.",
  "login.certFingerprint": "Fingerprint",
  "login.certConfirm": "Trust this certificate",
  "login.certReject": "Cancel",
  "reports.title": "Reports",
  "reports.subtitle": "What you have completed and where your time went.",
  "reports.tab.summary": "Summary",
  "reports.tab.time": "Time",
  "reports.tab.register": "Time log",
  "reports.print": "Print / Save as PDF",
  "reports.values": "Show values",
  "reports.period": "Period",
  "reports.from": "From",
  "reports.to": "To",
  "reports.period.today": "Today",
  "reports.period.week": "This week",
  "reports.period.month": "This month",
  "reports.period.days30": "Last 30 days",
  "reports.period.days90": "Last 90 days",
  "reports.period.all": "All time",
  "reports.period.custom": "Custom",
  "reports.assignee": "Assigned to",
  "reports.person": "Time recorded by",
  "reports.allTypes": "All types",
  "reports.invalidRange": "The end date must be on or after the start date.",
  "reports.exportError": "Export failed. Please try again.",
  "reports.loading": "Loading report…",
  "reports.trackingDisabled": "Time tracking is disabled in the selected scopes. The task summary is still available.",
  "reports.configure": "Configure time tracking",
  "reports.current": "Current state",
  "reports.activity": "Activity in the period",
  "reports.completedHint": "Counts tasks currently done and completed within the period. Reopened and deleted tasks are excluded.",
  "reports.metric.pending": "Pending now",
  "reports.metric.overdue": "Overdue now",
  "reports.metric.created": "Created in period",
  "reports.metric.completed": "Completed in period",
  "reports.evolution": "Task activity over time",
  "reports.week": "Week",
  "reports.projects": "By project",
  "reports.projects.client": "By client",
  "reports.empty": "No results match these filters.",
  "reports.status": "Status",
  "reports.trackedTasks": "Tasks with time recorded",
  "reports.trackedProjects": "Projects with time recorded",
  "reports.trackedProjects.client": "Clients with time recorded",
  "reports.visibility": "Time includes your sessions, and other people’s sessions only where you have permission to view them.",
  "reports.firstPage": "First page",
  "reports.nextPage": "Next page",
  "reports.generated": "Calculated at {at}",
  "reports.openSessions": "Includes {count} sessions in progress.",
  "error.invalid-report-filter": "Check the report dates, projects and page size.",
  "reports.allProjects": "All",
  "reports.paginationHint": "Totals include all matches. The list shows up to 100 results per page.",
  "chrono.edit": "Edit time",
  "chrono.add": "Add time",
  "chrono.taskChoice": "Task",
  "chrono.newTask": "New task",
  "chrono.existingTask": "Existing task",
  "chrono.title": "Title",
  "chrono.createdDone": "This task will be created as done, with this work session.",
  "chrono.selectTask": "Select a task",
  "chrono.refineSearch": "There are more tasks. Refine your search to find them.",
  "chrono.start": "Start",
  "chrono.end": "End",
  "chrono.running": "Running",
  "chrono.moveWarning": "I confirm that the whole task and all its work sessions will move to the selected project.",
  "chrono.saveError": "Could not save. Check the times, permissions, or whether the session changed; data has been reloaded.",
  "chrono.openTask": "Open task",
  "chrono.sameScope": "Choose a project in the same scope. The session has not moved.",
  "chrono.zoomOut": "Zoom out",
  "chrono.zoomIn": "Zoom in",
  "chrono.hint": "Drag edges to adjust time, a session to move it, or empty space to create one. Snaps to 5 minutes. Click a session to edit without dragging.",
  "error.session-forbidden": "You cannot edit this work session.",
  "error.session-conflict": "The session changed. Reload before editing.",
  "error.invalid-session": "Check the work session details.",
  "settings.showReports": "Show Reports in the main navigation",
  "settings.showReportsHint": "When turned off, Reports stays in your profile menu.",
  "reports.tools": "Export or print",
  "reports.exportContent": "CSV content",
  "reports.exportTasks": "Tasks · {metric}",
  "reports.registerTitle": "Recorded time",
  "reports.registerHint": "Time is recorded while Doing or by entering a duration when completing a task directly. Each session is kept separately.",
  "reports.filters": "Filters",
  "reports.clearFilters": "Clear filters",
  "reports.openRegister": "Open time log",
  "reports.timeDetails": "Time breakdown",
  "reports.closeDetails": "Close details",
  "reports.recordedTasks": "Time recorded on {count} tasks",
  "reports.seeCompleted": "View completed tasks",
  "reports.aboutData": "About this data",
  "tracking.cardsTitle": "Time on task cards",
  "tracking.showCards": "Show time on Doing and Done cards",
  "tracking.cardsHint": "Adds all visible sessions. While Doing, the counter updates every second; Done shows the total. Only in scopes with time tracking enabled.",
  "tracking.askDuration": "How much time did you spend?",
  "tracking.completionHint": "Time tracking is enabled for this scope. Enter the duration to complete the task and add a work session.",
  "tracking.minutes": "Duration in minutes",
  "tracking.saveComplete": "Save time and complete task",
  "tracking.invalidDuration": "Enter between 1 and 10,080 minutes.",
  "tracking.total": "Time spent: {duration}",
  "tracking.oneSegment": "1 session",
  "tracking.segments": "{count} sessions",
  "tracking.seconds": "{count}s",
  "widget.chooseColumn": "What should this widget show?",
  "widget.configure": "Configure",
  "widget.columnEmpty": "There are no tasks in this column.",
  "widget.advance": "→ {column}",
  "widget.pendingSync": "Saved on this device. Waiting to sync.",
  "widget.taskBoard.name": "Fem-ho · Board",
  "widget.taskBoard.description": "Inbox, To do and Doing. Tap a task to advance it.",
  "widget.taskBoard.open": "Open",
  "widget.taskBoard.viewAll": "View all",
  "widget.taskBoard.empty": "No tasks.",
  "widget.taskBoard.advance": "{task}. Move to {column}.",
  "external.credentials": "Credentials"
}
